import { H2 } from "components/atoms/H2";
import { DivinationTagCardListSkeleton } from "components/molecules/DivinationTagCardListSkeleton";
import { ImageCard } from "components/molecules/ImageCard";
import Link from "next/link";
import { Carousel } from "shared/components/atoms/Carousel";
import { Tag } from "shared/types";
import tw from "twin.macro";
import { Paths } from "utils/routes";

interface Props {
  tags: Tag[];
  disabled?: boolean;
}

export const DivinationList = ({ tags, disabled }: Props) => {
  return (
    <div>
      <H2 tw="mt-8 mx-5">🔮 使用する占術</H2>
      {tags ? (
        <Carousel
          data={tags}
          renderItem={(tag: Tag) => (
            <Link href={Paths.tags.show(tag.id)} passHref>
              <a
                onClick={(e) => {
                  if (disabled) {
                    e.preventDefault();
                  }
                }}
                css={disabled && tw`cursor-not-allowed`}
              >
                <ImageCard
                  src={tag.bannerUrl}
                  title={tag.name}
                  width={96}
                  height={137}
                />
              </a>
            </Link>
          )}
        />
      ) : (
        <DivinationTagCardListSkeleton />
      )}
    </div>
  );
};
